import {AoxMeasurementResult} from '../interfaces/biozoom-api/aox-measurement-result';
import {HrvMeasurementResult} from '../interfaces/biozoom-api/hrv-measurement-result';
import {PreciseAoxMeasurementResult} from '../interfaces/biozoom-api/precise-aox-measurement-result';
import {AppConfiguration} from '../interfaces/biozoom-api/app-configuration';

export const resultToString = (
  result: PreciseAoxMeasurementResult | AoxMeasurementResult | HrvMeasurementResult,
  serial: string,
) => {
  let reducedResult;
  reducedResult = {
    aox: result.aox,
    aox_q: result.aox_q,
    serial,
  };
  if ('precise_aox_std' in result) {
    const r: PreciseAoxMeasurementResult = result;
    reducedResult.aox = r.precise_aox;
    reducedResult.aox_std = r.precise_aox_std;
  }
  reducedResult.demo = !!result.demo;
  let values = Buffer.from(JSON.stringify(reducedResult)).toString('base64');
  // If base64 string contains "=", cut them off
  values = values.indexOf('=') < 0 ? values : values.substr(0, values.indexOf('='));
  return values;
};

/**
 * transform a given measurement result, alon with some meta information, into a url that can be opened to
 * display the result
 * @param result measurement result object
 * @param serial serial of the paired scanner
 * @param conf config object, containing all information about how to run he application
 * @param lang currently selected language
 */
export const getResult = (
  result: PreciseAoxMeasurementResult | AoxMeasurementResult | HrvMeasurementResult,
  serial: string,
  conf: AppConfiguration,
  lang: string,
  resultOnly = false,
  resultBaseUrl?: string,
) => {
  let resDict: Record<string, string | number | boolean> = {};

  if ('hrv_report_url' in result) {
    resDict = {
      bmi_age_gender_category: result.bmi_age_gender_category ?? undefined,
      hrv_bio_age_category: result.hrv_bio_age_category ?? undefined,
      hrv_age_category: result.hrv_age_category ?? undefined,
      product_j2bf: result.product_j2bf ?? undefined,
      std_nn: result.std_nn ?? undefined,
      bmi: result.bmi ?? undefined,
      hrv_bio_age: result.hrv_bio_age ?? undefined,
      mean_hr: result.mean_hr ?? undefined,
      x: result.x ?? undefined,
      x2: result.x2 ?? undefined,
      x3: result.x3 ?? undefined,
      x4: result.x4 ?? undefined,
      x6: result.x6 ?? undefined,
      serial,
      hr_age_gender_category: result.hr_age_gender_category ?? undefined,
      aox: result.aox ?? undefined,
      aox_int_result: result.aox_int_result ?? undefined,
      aox_q: result.aox_q ?? undefined,
    };
  } else {
    resDict = {
      aox: result.aox,
      aox_q: result.aox_q,
      serial,
    };
  }
  if ('precise_aox_std' in result) {
    const r: PreciseAoxMeasurementResult = result;
    resDict.aox = r.precise_aox;
    resDict.aox_std = r.precise_aox_std;
  }
  const resString = btoa(JSON.stringify(resDict));
  if (resultOnly) {
    return resString;
  }
  if (resultBaseUrl) {
    const url = new URL(resultBaseUrl);
    url.searchParams.set('values', resString);
    url.searchParams.set('lang', lang);
    return url.toString();
  }
  return `${conf.resultBaseUrl}?values=${resString}&lang=${lang}`;
};
